module.exports = __webpack_public_path__ + "img/sr.bfb11c03.png";